<template>
  <n-card class="card">
    <h1>{{ title }}</h1>
    <!--<n-input type="text" size="large" placeholder="Order Number" class="inputField" v-model:value="orderNumber"/> -->
<!--    <div>{{orderNumber}}</div>-->
    <!--<br/>
    <n-button type="default" @click="submit()" style="margin-top: 10px; background-color: white">Check My Order</n-button> -->
  </n-card>
</template>

<script>
import {NCard} from "naive-ui";
import {ref} from "vue";
import {useRouter} from "vue-router"
// import {useReCaptcha} from "vue-recaptcha-v3"

export default {
  name: "order-number-input-field",
  props: {
    title: String
  },
  components:{
    NCard,
    // NInput,
    // NButton
  },
  setup(){
    const router = useRouter()
    let orderNumber = ref('')
    // const notification = useNotification()
    // const { executeRecaptcha, recaptchaLoaded} = useReCaptcha();

    const submit = () => {
      // await recaptchaLoaded()
      // const token = await executeRecaptcha("homepage");

      // console.log({ token });
      if(orderNumber.value === ""){
        alert("Please Enter Your Sale Order Number")
      }else {
        router.push({ name: 'HelpCenter', params: { hashcode: orderNumber.value } })
      }

    }
    return{
      orderNumber,
      submit
    }
  }
}
</script>

<style scoped>
  .card{
    text-align: center;
    margin: auto;
    background-color: #333088;
    color: white;
  }
  .inputField{
    width: 50%;
  }
</style>